import { createContext } from 'react';
import { FuseType } from './type';

export const fuzzySearchIndexerContext = createContext<React.MutableRefObject<FuseType | undefined> | undefined>(undefined);
